










import { Component, Prop } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'

@Component
export default class AtomIconBook extends ComponentVue {
  @Prop({ type: Boolean, default: false })
  active!: boolean
}
